import { Accordion } from '@cinch-nx/shared-ui'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'
import { FAQQuestion } from '@cinch-nx/data-storyblok'
import { Heading, Secondary } from '@cinch-labs/design-system'
import styles from './store-faqs.module.css'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

interface StoreFaqsProps {
  title: string
  faqs: FAQQuestion[]
}

export const StoreFaqs = ({ title, faqs }: StoreFaqsProps) => {
  const { trackEvent } = useAnalytics()
  const accordionItems = faqs.map((faq: FAQQuestion) => ({
    title: faq.title,
    children: () => (
      <>
        {renderWithResolver(faq.body, {
          link: {
            openNewTab: true,
            adobeTracking: {
              eventName: 'FAQ link',
              type: TrackingEventTypes.ADOBE,
              data: {
                action: 'click',
                event: {
                  name: EventNames.click,
                  category: 'FAQ link',
                  label: `${faq.title} link clicked`,
                },
              },
            },
          },
        })}
      </>
    ),
  }))
  const FaqCategory = 'FAQ accordion'

  const handleItemClick = (isOpen: boolean, title: string) => {
    trackEvent({
      eventName: FaqCategory,
      type: TrackingEventTypes.ADOBE,
      data: {
        action: `${title} - ${isOpen ? 'open' : 'close'}`,
        event: {
          name: EventNames.click,
          category: FaqCategory,
          label: 'cinch store',
        },
      },
    })
  }

  const handleCtaClick = () => {
    trackEvent({
      eventName: FaqCategory,
      type: TrackingEventTypes.ADOBE,
      data: {
        action: 'View all FAQs',
        event: {
          name: EventNames.click,
          category: FaqCategory,
          label: 'cinch store',
        },
      },
    })
  }
  return (
    <section>
      <Heading id="faq-section" className={styles.heading}>
        {title}
      </Heading>
      <Accordion
        title={title}
        items={accordionItems}
        buttonId={title}
        sectionId="store-faq-section"
        onItemToggle={(itemIndex, isOpen) => handleItemClick(isOpen, title)}
      />
      <div className={styles.cantFindWhatYoureLookingFor}>
        <h3>Can’t find what you’re looking for?</h3>
        <Secondary
          classNames={{ button: styles.button }}
          element="a"
          href="/support"
          onClick={() => handleCtaClick()}
        >
          View all FAQs
        </Secondary>
      </div>
    </section>
  )
}
